export default "__VITE_ASSET__aRaBxJH$__"